module.exports = __webpack_public_path__ + "static/img/MX.c626f837.svg";